import React from 'react';
import { Particles } from './Particles';
export function Hero() {
  return <section className="relative overflow-hidden px-5 py-12 sm:px-8 lg:py-16" style={{
    background: 'linear-gradient(160deg, #0c0c0c 0%, #2d1b4e 100%)'
  }} data-id="element-71" data-mp="ejwk9bk3of7b">
      <Particles data-id="element-72" data-mp="9ipaj6yed5y0" />

      <div className="relative mx-auto max-w-4xl text-center" data-id="element-73" data-mp="4lqj4w64bd3i">
        <span className="inline-block rounded-full border border-gold/50 px-3 py-1 text-[10px] font-bold uppercase tracking-[0.14em] text-gold sm:text-[11px]" data-id="element-74" data-mp="4na0kq3ifu6v">
          Medicina Integrativa · Cristales · Hierbas · Numerología
        </span>

        <h1 className="mt-5 font-display text-[30px] font-bold leading-[1.14] text-white sm:text-[38px] lg:text-[48px]" data-id="element-75" data-mp="sb1bbp9ejz61">
          Elimina hasta 80 Tipos de Dolor Psicosomático en 7 Minutos al Día
          <span className="block text-gold" data-id="element-76" data-mp="3d1a7phvug7c8">Sin Fármacos ni Experiencia Previa</span>
        </h1>

        <p className="mx-auto mt-4 max-w-2xl text-[15px] leading-relaxed text-gold sm:text-[18px]" data-id="element-77" data-mp="382fi9x3dfkj5">
          El manual práctico de autosanación energética que te enseña a leer el lenguaje de tu
          cuerpo y sanar desde la raíz — incluso si los médicos te dijeron que solo es estrés.
        </p>
      </div>
    </section>;
}